<template>
  <div class="db-tw-mb-9">
    <DbTextarea
      :modelValue="modelValue"
      :inputAttrs="{ rows: 3, required: isMandatory }"
      v-on:update:model-value="$emit('update:modelValue', $event)"
    >
      {{ label }}
      <template
        v-if="v$.field.$error"
        v-slot:error
      >
        <DbRfpErrors :errors="v$.field.$errors" />
      </template>
    </DbTextarea>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { requiredIf, maxLength } from '@/utils/i18n-validators'

const props = withDefaults(
  defineProps<{
    /** Value of the field */
    modelValue?: string
    /** Label of the field */
    label: string
    /** If the field is mandatory */
    isMandatory: boolean
  }>(),
  {
    modelValue: '',
  },
)

defineEmits<{
  (e: 'update:modelValue', modelValue: string | number): void
}>()

const state = computed(() => {
  return {
    field: props.modelValue,
  }
})

const rules = computed(() => {
  return {
    field: { required: requiredIf(props.isMandatory), maxLengthValue: maxLength(3000) },
  }
})

const v$ = useVuelidate(rules, state, { $autoDirty: true })
</script>
